<template>
    <div v-loading="loading" element-loading-text="推送中，请稍候...">
        <div class="info_case">
            <el-form label-width="120px" :model="infoData" size="small">
                <el-form-item label="车辆号码">
                    <el-input style="width: 100%;" v-model="infoData.carPlatNo" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="车辆类型">
                    <el-select style="width: 100%;" v-model="infoData.carClass" filterable placeholder="请选择">
                        <el-option v-for="item in tempList.vehList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="违法时间">
                    <el-date-picker style="width: 100%;" v-model="infoData.accidentTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="违法地点">
                    <el-input style="width: 100%;" v-model="infoData.accidentAddress" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="违法行为">
                    <!-- <el-autocomplete style="width: 100%;" v-model="autocomplete_value" :fetch-suggestions="((e, cb) => {getRoadCode(e, cb, 3)})" @select="handleSelect($event, 3)" placeholder="请输入"></el-autocomplete> -->
                    <el-input style="width: 100%;" type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="infoData.accidentDesc" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="btn_case" label-width="0">
                    <el-button type="primary" @click="onSubmit">推送</el-button>
                    <el-button plain @click="onClose()">关闭</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import config from "@/common/env.js";
    import tempList from "../json/index.js"

    export default {
        props: ["componentId"],
        data () {
            return {
                loading: false,
                tempList: tempList,
                infoData: {
                    recordId: null,
                    carPlatNo: null,
                    carClass: null,
                    accidentTime: null,
                    accidentAddress: null,
                    accidentDesc: null,
                },
                autocomplete_value: null,

            }
        },
        computed: {
            
        },
        created () {
            this.infoData.recordId = this.componentId;
        },
        mounted () {
            
        },
        methods: {
            // 道路代码 and 违法代码
			getRoadCode(e, cb, n) {
				// console.log(e)
				// console.log(n)
				if(n == 1) {
					
				} else if(n == 2) {
					
				} else if(n == 3) {
					this.$axios.post(`/admin/appointment/illegalList`, { name: e }).then((res) => {
						let data = this.AppUtils.checkResponse(res);
						if (data.code == 0) {
							this.textLists = data.data;
							this.textLists.map(item => {
								item.value = item.illegalInfo;
							})
							cb(this.textLists);
							this.$forceUpdate();
						}
					})
				}
			},
			handleSelect(e, n) {
				console.log(e)
				// console.log(n)
				if(n == 1) {
					
				} else if(n == 2) {
					
				} else if(n == 3) {
					this.infoData.accidentDesc = e.value;
				}
			},

            onSubmit() {
                let params = JSON.parse(JSON.stringify(this.infoData));
                let msg = "";
                console.log(params)
                
                if(params.carPlatNo == null) {
                    msg = "请填写车辆号码";
                } else if(params.carClass == null) {
                    msg = "请填写车辆类型";
                } else if(params.accidentTime == null) {
                    msg = "请填写违法时间";
                } else if(params.accidentAddress == null) {
                    msg = "请填写违法地点";
                } else if(params.accidentDesc == null) {
                    msg = "请填写违法行为";
                }

                if(msg != "") {
                    return this.$message.error(msg);
                }
                // return
                this.loading = true;
                this.$axios.post(`/admin/appointment/generateFirstWf/simple`, params).then(res => {
                    this.loading = false;
                    let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
                    if(code == 0) {
                        this.$message.success("推送成功");
                        this.onClose({penaltiesImage: data.normalFirstWFImage, ucode: data.ucode});  
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(err => {
                    this.loading = false;
                })
            },

            onClose(json) {
                this.$emit("onClose", json);
            },


        }
    }
</script>

<style scoped lang="scss">
    .info_case {
        width: 90%;
        margin: 0 auto;
    }
    .info_case /deep/ .el-date-editor .el-input__inner {
        width: inherit;
    }
    .btn_case {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// firstWs.vue?012fa2f6